export default () => import(/* webpackChunkName: 'coffee/wechat-community/subscribe-live' */ './SubscribeLive');